import api from "./api";

export const meetingService = {
  createMeeting: async (participantId) => {
    const response = await api.post("/meetings", { participantId });
    return response.data;
  },
  endMeeting: async (meetingId) => {
    const response = await api.patch(`/meetings/${meetingId}/end`);
    return response.data;
  },
};
